export const smsSettingsQueryKeys = {
  all: ["smsSettings"] as const,
  templates: () => [...smsSettingsQueryKeys.all, "templates"] as const,
  template: (id: string) => [...smsSettingsQueryKeys.templates(), id] as const,
  settings: () => [...smsSettingsQueryKeys.all, "settings"] as const,
};